module.exports = __webpack_public_path__ + "img/language.cb33f258.png";